'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { t } from '../../helpers/translate.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import '../../mixins/media.js';
import { keyboardFocusShadowAfter } from '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import { textStyle } from '../../mixins/textStyle.js';
import { resetButton } from '../../mixins/resetButton.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import { DangerIcon } from '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import { OkIcon } from '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';
import { Text } from '../Text/Text.js';

var StepStatus;
(function (StepStatus) {
  StepStatus["Active"] = "active";
  StepStatus["Completed"] = "completed";
  StepStatus["Error"] = "error";
  StepStatus["Unfinished"] = "unfinished";
  StepStatus["Disabled"] = "disabled";
})(StepStatus || (StepStatus = {}));
const mapStatus = step => {
  if (step.isActive) return StepStatus.Active;
  if (step.isError) return StepStatus.Error;
  if (step.isCompleted) return StepStatus.Completed;
  if (step.isDisabled) return StepStatus.Disabled;
  return StepStatus.Unfinished;
};
const mapStatusToCSSProp = cssProp => css(["", ""], ({
  theme
}) => switchProp('status', {
  disabled: css(["", ":", ";"], cssProp, theme.components.stepper.colorDisabled),
  active: css(["", ":", ";"], cssProp, theme.components.stepper.colorActive),
  unfinished: css(["", ":", ";"], cssProp, theme.components.stepper.colorUnfinished),
  completed: css(["", ":", ";"], cssProp, theme.components.stepper.colorCompleted),
  error: css(["", ":", ";"], cssProp, theme.components.stepper.colorError)
}));
const StyledLabelContainer = styled.div.withConfig({
  componentId: "sc-11x4eh-0"
})(["", " display:flex;cursor:default;", " ", ""], resetButton, ({
  status,
  onClick
}) => status !== StepStatus.Disabled && typeof onClick === 'function' && css(["cursor:pointer;&:hover{text-decoration:underline;text-underline-offset:4px;", "}", ""], mapStatusToCSSProp('text-decoration-color'), keyboardFocusShadowAfter({
  offset: -3,
  element: '> span'
})), ({
  spaceAfter
}) => spaceProp(spaceAfter));
const StyledDot = styled.div.withConfig({
  componentId: "sc-11x4eh-1"
})(["background-color:", ";border-radius:50%;flex-shrink:0;height:", ";margin-right:", ";text-align:center;width:", ";", " display:flex;justify-content:center;align-items:center;color:", ";", ""], ({
  theme
}) => theme.components.stepper.colorDefault, ({
  theme
}) => theme.components.stepper.dotWidthHeight, ({
  theme
}) => theme.components.stepper.dotMarginRight, ({
  theme
}) => theme.components.stepper.dotWidthHeight, mapStatusToCSSProp('background-color'), ({
  theme
}) => theme.components.stepper.dotColor, textStyle('label'));
const StyledLabel = styled(Text).withConfig({
  componentId: "sc-11x4eh-2"
})(["padding-top:1px;color:", ";", ""], ({
  theme
}) => theme.components.stepper.colorDefault, mapStatusToCSSProp('color'));
const StyledDotLabel = styled(Text).withConfig({
  componentId: "sc-11x4eh-3"
})(["margin-top:-2px;"]);
const StepLabel = /*#__PURE__*/withTitan(_a => {
  var {
      label,
      step,
      as,
      isCompleted,
      isActive,
      isError,
      isDisabled,
      spaceAfter,
      onClick,
      labelStepCompleted = 'Stap {step}: Afgerond.',
      labelStepError = 'Stap {step}: Error.',
      labelStep = 'Stap {step}.',
      testId = 'stepLabel'
    } = _a,
    rest = __rest(_a, ["label", "step", "as", "isCompleted", "isActive", "isError", "isDisabled", "spaceAfter", "onClick", "labelStepCompleted", "labelStepError", "labelStep", "testId"]);
  const dotContent = step => {
    if (isCompleted && !isActive) return jsx(OkIcon, {});
    if (isError && !isActive) return jsx(DangerIcon, {});
    return jsx(StyledDotLabel, {
      type: "label",
      children: step
    });
  };
  const dotLabel = step => {
    if (isCompleted && !isActive) return t(labelStepCompleted, {
      step
    });
    if (isError && !isActive) return t(labelStepError, {
      step
    });
    return t(labelStep, {
      step
    });
  };
  const status = mapStatus({
    isCompleted,
    isActive,
    isError,
    isDisabled
  });
  return jsxs(StyledLabelContainer, Object.assign({
    as: as,
    "data-test-id": testId,
    disabled: isDisabled || status === StepStatus.Disabled,
    spaceAfter: spaceAfter,
    status: status,
    type: as === 'button' ? 'button' : undefined,
    onClick: onClick
  }, rest, {
    children: [step && jsx(StyledDot, {
      "aria-label": dotLabel(step),
      status: status,
      children: dotContent(step)
    }), label && jsx(StyledLabel, {
      status: status,
      type: "labelBold",
      children: label
    })]
  }));
}, {
  name: 'StepLabel'
});

export { StepLabel, StepStatus };
//# sourceMappingURL=StepLabel.js.map
